export const landing4 = {
  navbar: {
    solutions: "Why Bespire?",
    useCases: "Who is it for?",
    howItWorks: "How It Works",
    pricing: "Pricing",
    faq: "FAQ",
    about: "About Us",
    whyBespireItems: [
      { label: "Brand & strategy", subtitle: "Brand identity, personas, business plan, competitor analysis", icon: "Palette", href: "/brand-strategy" },
      { label: "Website, content, SEO", subtitle: "Website in minutes, blog posts, translations, SEO", icon: "Globe", href: "/website-builder" },
      { label: "Booking & calendar", subtitle: "Online booking, reminders, group classes — your calendar runs itself", icon: "Calendar", href: "/booking-system" },
      { label: "Marketing & social", subtitle: "Campaigns, posts, ads, email marketing", icon: "Megaphone", href: "/marketing-automation" },
      { label: "Admin & finance", subtitle: "Business overview, reports, monthly closing, capacity and cost planning — payments inside the system", icon: "Wallet", href: "/admin-finance" },
      { label: "Customer relations", subtitle: "Recall, follow-up, reviews, community", icon: "Users", href: "/customer-relations" },
      { label: "Always-on AI assistant", subtitle: "Daily brief, tasks, proactive suggestions, reports", icon: "Bot", href: "/daily-assistant" },
    ],
    whyBespireCta: "See all AI capabilities →",
    waitlistButton: "Start now – free",
    callbackButton: "Request callback",
    login: "Log in",
    startNow: "Start now",
    startNowFree: "Start now – free",
    callbackShort: "Call me back",
    menuLabel: "Menu",
    personasGroups: {
      healthBeauty: "Health & beauty",
      coachingHealth: "Coaching & wellbeing",
    },
    notFoundProfession: "Don't see your profession? — Bespire works for any service provider.",
    startNowArrow: "Start now →",
    callbackArrow: "Or request a callback →",
    personasCol1: [
      { label: "Yoga & Pilates instructors", href: "/for/yoga-pilates-instructors" },
      { label: "Fitness & Personal trainers", href: "/for/fitness-personal-trainers" },
      { label: "Beauticians & Salons", href: "/for/beauticians-beauty-salons" },
      { label: "Massage therapists", href: "/for/massage-therapists" },
      { label: "Hairdressers & Barbers", href: "/for/hairdressers-barbers" },
      { label: "Nail technicians", href: "/for/nail-technicians" },
      { label: "Physiotherapists", href: "/for/physiotherapists" },
    ],
    personasCol2: [
      { label: "Consultants & Business Coaches", href: "/for/consultants-business-coaches" },
      { label: "Psychologists & Mentors", href: "/for/psychologists-mentors" },
      { label: "Nutrition consultants", href: "/for/nutritionists" },
      { label: "Therapists & Coaches", href: "/for/therapists-coaches" },
      { label: "Sports clubs", href: "/for/sport-clubs" },
      { label: "Photographers & Videographers", href: "/for/photographers-videographers" },
    ],
  },
  footer: {
    description: "A platform for creators, entrepreneurs and small businesses to easily build your digital presence and grow your revenue.",
    product: "Product",
    websiteBuilder: "Website Builder",
    bookingSystem: "Booking System",
    marketingAutomation: "Marketing Automation",
    pricing: "Pricing",
    forWho: "Who is it for?",
    forWhoHealthBeauty: "Health & Beauty",
    forWhoCoachingHealth: "Coaching & Wellbeing",
    yogaPilates: "Yoga & Pilates Instructors",
    fitnessTrainers: "Fitness & Personal Trainers",
    beauticians: "Beauticians & Salons",
    massageTherapists: "Massage Therapists",
    hairdressers: "Hairdressers & Barbers",
    nailTechnicians: "Nail technicians",
    physiotherapists: "Physiotherapists",
    consultants: "Consultants & Coaches",
    psychologists: "Psychologists & Mentors",
    nutritionists: "Nutrition consultants",
    therapistsCoaches: "Therapists & Coaches",
    sportClubs: "Sports clubs",
    photographers: "Photographers & Videographers",
    contact: "Contact",
    location: "Budapest, Hungary",
    allRightsReserved: "All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    cookiePolicy: "Cookie Policy",
  },
  newsletter: {
    title: "Request a free callback",
    subtitle: "Leave your phone number and we'll call you back within 48 hours — completely free, no obligations.",
    namePlaceholder: "Your name (e.g. John Smith)",
    phonePlaceholder: "Your phone number (e.g. +36 30 123 4567)",
    selectProfession: "Select your profession",
    professions: {
      fitness: "Fitness & Personal Trainer",
      yoga: "Yoga & Pilates Instructor",
      physiotherapist: "Physiotherapist & Physical Therapist",
      sportsClub: "Sports Club",
      consultant: "Consultant & Business Coach",
      trainer: "Therapist & Coach",
      nutritionist: "Nutrition Consultant",
      psychologist: "Psychologist & Mentor",
      hairdresser: "Hairdresser & Barber",
      photographer: "Photographer & Videographer",
      beautician: "Beautician & Beauty Salon",
      massage: "Massage Therapist",
      nail: "Nail Technician",
      other: "Other",
    },
    setupOption: {
      label: "Would you like us to fully set up your site?",
      yes: "Yes, I want full setup (50,000 Ft + VAT, one-time fee)",
      no: "No, I'll manage it myself",
    },
    websiteStatus: {
      label: "Do you already have a website?",
      hasWebsite: "Yes, I have a website",
      noWebsite: "No, I'm just starting",
      websitePlaceholder: "Enter your website URL (e.g. www.example.com)",
    },
    submitButton: "Start now – free",
    privacyNote: "We keep your data confidential. The callback is completely free.",
    callbackNote: "We'll call you back within 48 hours on business days.",
    freeBadge: "100% free",
  },
  loading: "Loading...",
  seo: {
    title: "Bespire - AI Assistant for Service Providers",
    description: "AI-powered website, booking system and marketing automation for hairdressers, trainers, consultants and service businesses.",
    keywords: "AI assistant, booking system, website builder, marketing automation, hairdresser, fitness, yoga, salon",
  },
  hero: {
    badge: "Full AI assistant for service providers",
    title: "Not just a website builder — it helps run your whole business",
    subtitle: "Website, booking, marketing, campaigns, analytics, new products, hiring — your AI assistant works with you every day.",
    rotatingPrefix: "All in one place for",
    rotatingSuffix: "",
    rotatingAudiences: ["yoga instructors", "beauticians", "consultants", "trainers", "therapists", "influencers"],
    description: "Professional online presence, 24/7 client bookings, AI helps you acquire new customers.",
    cta: "Sign up free",
    ctaSecondary: "Request a callback",
    microcopy: "3-day free trial · No card required · Cancel anytime",
    watchVideo: "Watch Video",
    forWho: "For hairdressers, trainers, beauticians and all service businesses",
    trustIndicators: {
      setup: "10 min setup",
      trial: "3-day trial",
      noCard: "No card required",
    },
    floatingBadges: {
      newClients: "Free signup",
      aiActive: "No card required",
    },
    chat: {
      title: "Bespire AI Assistant",
      online: "Online",
      demoBadge: "Live chat demo",
      messages: [
        {
          role: "assistant" as const,
          content: "Hi! 👋 I'm your Bespire AI assistant. I'll help you build your website in minutes. What kind of business do you have?",
        },
        {
          role: "user" as const,
          content: "I'm a personal trainer and I'd like a professional website where my clients can book sessions.",
        },
        {
          role: "assistant" as const,
          content: "Great! I'm already building your personal trainer website. Here's what I'm setting up:",
          list: [
            "✅ Booking system – clients can book 24/7",
            "✅ Services page – showcase your training packages",
            "✅ About section – professional presentation",
            "✅ Contact – automatic email confirmations",
          ],
        },
        {
          role: "user" as const,
          content: "Awesome! Can I also set up pricing?",
        },
        {
          role: "assistant" as const,
          content: "Of course! You can easily edit your pricing packages. Your site is ready – check out the preview! 🚀",
        },
      ],
    },
  },
  stats: {
    title: "Success in Numbers",
    subtitle: "What we've achieved together with our clients",
    items: [
      { label: "Happy Clients" },
      { label: "Appointments Managed" },
      { label: "Time Saved" },
      { label: "Rating" },
    ],
  },
  comparison: {
    title: "Why Bespire?",
    subtitle: "Compare with other solutions",
    partial: "Partial",
    columns: {
      feature: "Feature",
      bespire: "Bespire",
      traditional: "Traditional",
      wordpress: "WordPress",
      manual: "Custom build",
    },
    cta: "Try it for free",
    features: [
      { name: "Website builder", bespire: true, traditional: "partial", wordpress: true, manual: false },
      { name: "Booking system", bespire: true, traditional: false, wordpress: "partial", manual: false },
      { name: "Marketing automation", bespire: true, traditional: false, wordpress: false, manual: false },
      { name: "AI assistant", bespire: true, traditional: false, wordpress: false, manual: false },
      { name: "Setup time", bespire: "10 min", traditional: "2-4 weeks", wordpress: "1-2 days", manual: "1-3 months" },
      { name: "Technical knowledge required", bespire: false, traditional: "partial", wordpress: "partial", manual: true },
      { name: "Monthly cost", bespire: "€30", traditional: "€150+", wordpress: "€60+", manual: "€300+" },
      { name: "Mobile app", bespire: true, traditional: false, wordpress: false, manual: "partial" },
      { name: "Customer support", bespire: true, traditional: "partial", wordpress: "partial", manual: false },
    ],
  },
  pricing: {
    title: "Simple, transparent pricing",
    subtitle: "Choose the plan that suits you",
    heading: "Simple pricing. Two paths, one price.",
    subheading: "No surprises. Cancel any time.",
    diy: {
      title: "Do it yourself, with AI",
      price: "€30",
      priceSuffix: " / month",
      note: "3-day full access, starts free",
      features: [
        "Full website with AI assistant",
        "Booking system and automatic reminders",
        "Sell digital products, courses and passes",
        "AI-generated marketing content",
        "Email marketing automation",
        "Custom domain",
        "Unlimited team members",
        "AI assistant included in your plan",
      ],
      cta: "Start now – free",
      footnote: "No card needed · Live in 10 minutes",
    },
    setup: {
      title: "We set it up for you",
      price: "€150",
      priceSuffix: " one-time",
      note: "one-time fee, then €30 / month",
      features: [
        "Full site in your brand",
        "Products and services uploaded",
        "Booking and payments configured",
        "Domain setup and technical configuration",
        "Starter marketing content",
        "SEO and Google setup",
        "Personal onboarding and training",
        "Satisfaction guarantee",
      ],
      cta: "Request a callback",
      footnote: "We'll call you within 30 minutes on business days · free, no obligation",
    },
  },
  aiCreditExamples: {
    badge: "What AI helps with",
    title: "How you'll use it day to day",
    subtitle: "Every AI feature is included in your plan — from daily tasks to campaign seasons.",
    legendSimple: "Daily",
    legendComplex: "During campaigns",
    examples: [
      {
        task: "Text posts and newsletters",
        credits: "Daily task",
        description: "Create attention-grabbing text content for social, blog or email."
      },
      {
        task: "Instagram post with image",
        credits: "Regular",
        description: "Generate a unique graphic and matching caption for a social post."
      },
      {
        task: "Complete website",
        credits: "Bigger task",
        description: "Generate a professional multi-page website tailored to your brand, with images and copy."
      }
    ]
  },
  aiCredits: {
    badge: "AI assistant included",
    title: "AI for your daily work — included in your plan",
    subtitle: "The AI assistant and AI generation (text, image, website) are part of your monthly fee. No separate AI charge, no counting, no surprises — use it for normal business work.",
    whatIsTitle: "What does included mean?",
    whatIsDescription: "Your plan fee covers the AI assistant and AI generation for normal daily business use. During campaign seasons, heavier usage or extreme automated use, extra capacity may be needed.",
    usageExamples: [
      {
        title: "Website generation",
        description: "Create a professional website after answering a few questions."
      },
      {
        title: "Image generation",
        description: "Create unique images and graphics for your brand."
      },
      {
        title: "Marketing content",
        description: "Automatic writing of social posts and email campaigns."
      },
      {
        title: "Business suggestions",
        description: "Personalized growth tips and analytics."
      }
    ],
    benefits: [
      {
        title: "Time savings",
        description: "What would take you hours, AI does in minutes.",
        highlight: ""
      },
      {
        title: "No expertise needed",
        description: "No design or marketing skills required — the AI does it for you."
      },
      {
        title: "AI for your daily work",
        description: "No separate AI charge, no counting. Use it within your plan, whenever you need."
      },
      {
        title: "Simple, transparent pricing",
        description: "Flat monthly fee — no surprise costs, no add-ons."
      }
    ],
    freeCredits: {
      title: "3-day free trial",
      description: "3 days of full access to the AI assistant and every feature — no card, no commitment."
    },
    note: "The AI assistant and all AI generation are part of your plan.",
    freeFeatures: {
      title: "What's included in your plan",
      items: [
        "Appointment booking and calendar",
        "Sales and payment processing",
        "Customer management",
        "Core system features",
        "Statistics and reports"
      ]
    },
    howItWorks: {
      title: "How do you get started?",
      steps: [
        {
          icon: "gift",
          title: "3-day free trial",
          description: "Sign up and try it with full access — no card, no commitment."
        },
        {
          icon: "cart",
          title: "Subscribe after the trial",
          description: "If you like it, pick Growth or Premium. Cancel anytime, no long-term commitment."
        },
        {
          icon: "clock",
          title: "AI included in your plan",
          description: "No separate AI charge, no counting — the AI assistant and AI generation are part of your plan."
        }
      ],
      packagesIntro: "",
      popularBadge: "Most popular",
      creditsLabel: "",
      vatLabel: "+ VAT",
      oneTimeNote: "",
      packages: []
    },
    buyModal: {
      title: "Choose a plan",
      subtitle: "Pick the plan that fits you.",
      oneTimeBadge: "3-day free trial · No card required",
      whatFitsTitle: "What's included?",
      selectedLabel: "Selected",
      cancel: "Cancel",
      buyCta: "Choose",
      successToast: "Subscription successful (mock)"
    }
  },
  painPoints: {
    title: "Do these challenges sound familiar?",
    subtitle: "You're not alone. Every service business struggles with these problems.",
    dividerMessage: "But there's a solution! ⬇️",
    points: [
      {
        title: "Amateur or outdated presence",
        description: "You don't have a professional website, or it would be too complicated and expensive to get one made.",
      },
      {
        title: "Complicated booking system nobody uses",
        description: "It's filled with features you don't need, and your clients don't understand how to book with it.",
      },
      {
        title: "No time to focus on growth",
        description: "Administration, managing tools, manual work - most of your day is not spent with clients.",
      },
      {
        title: "Marketing? Maybe when I have time...",
        description: "You need to acquire new clients, but you don't have time to post, plan campaigns, or create content.",
      },
    ],
  },
  impact: {
    badge: "BY THE NUMBERS",
    titleBefore: "Instead of empty promises, ",
    titleAccent: "real results",
    titleAfter: " that Bespire users talk about.",
    stats: [
      {
        value: "10+ hrs",
        label: "Weekly savings",
        description: "No more juggling four tools — one place, automated by AI.",
      },
      {
        value: "$0",
        label: "Setup cost",
        description: "No developer. No designer. The AI handles everything for you.",
      },
      {
        value: "24 / 7",
        label: "Online booking",
        description: "Clients book day and night. The system never closes.",
      },
      {
        value: "5×",
        label: "Revenue streams",
        description: "Services, memberships, courses, products, workshops — one platform.",
      },
      {
        value: "10 min",
        label: "and usable business tools are in your hands",
        description: "Own website, marketing plan, booking calendar, quote, weekly report — the AI prepares it for you.",
      },
      {
        value: "80%",
        label: "Less admin",
        description: "Reminders, payments, client records — the machine handles it.",
      },
    ],
  },
  workflowSpine: {
    badge: "HOW IT WORKS",
    title: "Basics → Plan → Tasks → Automation → Report",
    subtitle: "Bespire is not a collection of separate tools. It's one workflow that follows your business logic.",
    steps: [
      { title: "Basics", description: "Brand, personas, business plan, competitors — a living document library." },
      { title: "Plan", description: "44 planning workflows across 5 themes: acquisition, retention, capacity, offer, team." },
      { title: "Tasks", description: "Half the tasks stay with you, half with AI. Draft, approve, run history." },
      { title: "Automation", description: "Win-back, pass expiry, no-show, review requests — runs on its own." },
      { title: "Report", description: "Weekly and monthly performance, AI commentary, next step — not just numbers." },
    ],
  },
  proactiveTriggers: {
    badge: "PROACTIVE AI",
    title: "What the assistant notices on its own",
    subtitle: "It doesn't wait for you to ask. It speaks up based on real data before it becomes a problem.",
    items: [
      { trigger: "14 empty slots this week", suggestion: "Capacity plan", outcome: "Recall campaign to lapsed clients — 30-40% return rate." },
      { trigger: "Client inactive for 90 days", suggestion: "Win-back campaign", outcome: "Personalized offer based on their favorite service — they rebook." },
      { trigger: "Pass expires in 7 days", suggestion: "Renewal message", outcome: "Automatic renewal link — less lost revenue." },
      { trigger: "2 hours after no-show", suggestion: "Rebooking offer", outcome: "Polite reminder + next free slot — slot refilled." },
    ],
  },
  taskBoard: {
    badge: "CO-WORKER",
    title: "You and the AI on the same task board",
    subtitle: "Not a separate chatbot. Bespire splits daily tasks between you and AI, then waits for your approval.",
    meColumnTitle: "Mine",
    aiColumnTitle: "AI's",
    aiBadge: "Working",
    meTasks: [
      { title: "Review peak-hour pricing", note: "AI drafted a proposal — decision pending" },
      { title: "Confirm new group class slot", note: "3 sign-ups, needs final confirmation" },
    ],
    aiTasks: [
      { title: "Recall message for Anna Kovács", note: "No booking in 3 weeks", status: "Pending approval · WhatsApp" },
      { title: "Weekly Instagram post drafts", note: "Group class and opening hours", status: "Scheduled · today 18:00" },
      { title: "Win-back campaign for 12 lapsed clients", note: "Inactive for 90 days", status: "Running · first replies coming in" },
    ],
    footer: "AI never decides your money or your clients on its own. It drafts, you approve, it runs.",
  },
  monthlyReport: {
    badge: "MONTH-END REPORT",
    title: "What you see at month end — numbers and next steps",
    subtitle: "Not a static table. Bespire summarizes what happened and tells you what to do next.",
    period: "June 2026",
    periodNote: "Auto-generated monthly closing",
    aiGeneratedLabel: "AI generated",
    kpis: [
      { label: "Monthly revenue", value: "1,847,000 HUF", delta: "+12% vs last month", positive: true },
      { label: "Capacity used", value: "78%", delta: "+6% improvement", positive: true },
      { label: "New clients", value: "18", delta: "+5 vs last month", positive: true },
      { label: "Lapsed", value: "23", delta: "needs attention", positive: false },
    ],
    insightTitle: "Top recommendation for next month",
    insight: "Wednesday morning slots have been declining for 2 months. Suggestion: 10% off morning package, targeted WhatsApp campaign to 45 lapsed clients.",
  },
  channels: {
    title: "You don't have to log in for it to work",
    subtitle: "The assistant reaches you where you already are. Measurement and ads run from the same place.",
    items: [
      { name: "WhatsApp", description: "Tasks, approvals, reminders — straight on your phone." },
      { name: "Google", description: "Measurement data, SEO suggestions and performance tracking." },
      { name: "Meta Ads", description: "Ad campaigns, posts and audience analysis from one place." },
      { name: "Browser", description: "The full Bespire interface on any device, no download needed." },
    ],
    footer: "No separate app, no new login. Bespire works with you through the channels you already use.",
  },
  solutions: {
    title: "One AI assistant that truly does it all",
    subtitle: "It doesn't just build a website or handle bookings. It works with you every day — from branding to admin.",
    solutionLabel: "Area",
    ctaTrial: "Try it free for 3 days",
    ctaCapabilities: "See all capabilities →",
    items: [
      {
        id: "solution-brand",
        icon: "Palette",
        title: "Brand & strategy",
        description: "It walks you through rethinking your brand and business plan if needed — then continuously fine-tunes it, not just once.",
        features: [
          "Brand identity and key messages",
          "Personas and positioning",
          "Business and marketing plan",
          "New competitor analysis anytime",
        ],
        chat: {
          title: "Brand assistant",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Hi! 🎨 Let's look at your brand. What would you like clearer?" },
            { role: "user" as const, content: "I don't feel I'm speaking to the right person. Help me rethink my personas." },
            { role: "assistant" as const, content: "Sure. Based on your current customer data and bookings, I see this:", list: [
              "👤 Main persona: 30–45, working parents, weekend slots",
              "👤 Hidden segment: 25–35 athletes, evening slots",
              "👤 Missed: 50+ recovery-focused",
            ] },
            { role: "user" as const, content: "Let's focus on the 25–35 athletes. Draft a brief for them?" },
            { role: "assistant" as const, content: "Done. New message, new colors, new landing section — I'll ship it once approved. 🚀" },
          ],
        },
      },
      {
        id: "solution-web",
        icon: "Globe",
        title: "Website, content, SEO",
        description: "Not only builds your website — it keeps filling it with content, optimizing it, and translating it into new languages.",
        features: [
          "New blog posts with keywords",
          "SEO analysis and suggestions",
          "Translate the site to a new language",
          "Generate new images and media",
        ],
        chat: {
          title: "Website & content",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Hi! 🌐 What can I help with on your site today?" },
            { role: "user" as const, content: "I need a blog post about winter recovery, in English too." },
            { role: "assistant" as const, content: "Sure. I made two versions:", list: [
              "✍️ Post: 'Winter recovery — 5 tips to start today'",
              "🌍 Translation ready for your other language",
              "🔍 SEO optimized for 3 keywords",
            ] },
            { role: "user" as const, content: "Great. Write the meta description and publish it too?" },
            { role: "assistant" as const, content: "Done. Published, sitemap updated, submitted to Google. 📈" },
          ],
        },
      },
      {
        id: "solution-products",
        icon: "Package",
        title: "Booking & calendar",
        description: "Online booking, group classes, reminders, no-show follow-up — your calendar runs itself.",
        features: [
          "Online booking 24/7",
          "Group and 1:1 sessions",
          "Automatic reminders and calendar sync",
          "No-show follow-up, waitlist, win-back",
        ],
        chat: {
          title: "Products & booking",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Hi! 📦 New service or bundle to set up?" },
            { role: "user" as const, content: "I'd like a 10-session pass with a discount." },
            { role: "assistant" as const, content: "Here's how it looks:", list: [
              "🎫 10-session pass — $180 (15% off)",
              "⏱️ Valid for 3 months",
              "📅 Book directly against the pass",
            ] },
            { role: "user" as const, content: "Add a starter combo for new clients too." },
            { role: "assistant" as const, content: "Created 'Start' bundle: 3 sessions + consultation. Live on the site. ✅" },
          ],
        },
      },
      {
        id: "solution-marketing",
        icon: "Megaphone",
        title: "Marketing & social",
        description: "Campaigns, posts, ads — not from templates, but based on your own clients, services and bookings.",
        features: [
          "Automatic Instagram/Facebook posts",
          "Ad copy and image generation",
          "Email campaigns for recall",
          "Full monthly campaign plan",
        ],
        chat: {
          title: "Marketing assistant",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Hi! 📣 How's the month going? Let's push the new group class?" },
            { role: "user" as const, content: "Yes, I need 3 posts and one ad for it." },
            { role: "assistant" as const, content: "Done, here's the plan:", list: [
              "📸 3 Instagram posts — Mon, Wed, Fri",
              "🎯 Facebook ad — 25–40, your city",
              "✉️ Email to past clients with first-session discount",
            ] },
            { role: "user" as const, content: "Launch it live, with a $10/day ad budget." },
            { role: "assistant" as const, content: "Live. I'll report daily and suggest tweaks. 📊" },
          ],
        },
      },
      {
        id: "solution-finance",
        icon: "Wallet",
        title: "Admin & finance",
        description: "Invoicing, reminders, reports — admin takes the paperwork off your plate so you can focus on your craft.",
        features: [
          "Automatic invoicing after bookings",
          "Payment reminders on overdue",
          "Monthly and quarterly reports",
          "AI commentary on revenue trends",
        ],
        chat: {
          title: "Admin assistant",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Hi! 💼 Weekly report is ready, want to see it?" },
            { role: "user" as const, content: "Give me the headlines." },
            { role: "assistant" as const, content: "Quick summary:", list: [
              "💰 Revenue: $1,180 (+8% vs last week)",
              "📅 Bookings: 47 (2 cancellations)",
              "⚠️ 3 outstanding invoices — send reminders?",
            ] },
            { role: "user" as const, content: "Yes, and send a monthly report to my accountant." },
            { role: "assistant" as const, content: "Reminders out, monthly PDF emailed to your accountant. ✅" },
          ],
        },
      },
      {
        id: "solution-customers",
        icon: "Users",
        title: "Customer relations",
        description: "Recall, follow-up, review management — so your clients don't forget you, and you get better reviews.",
        features: [
          "Recall campaigns for past clients",
          "Follow-up messages after bookings",
          "Review requests and reply drafts",
          "Birthdays and loyalty programs",
        ],
        chat: {
          title: "Customer assistant",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Hi! 👥 12 clients haven't booked in 3 months. Send a recall offer?" },
            { role: "user" as const, content: "Yes, but personalized — not a template." },
            { role: "assistant" as const, content: "Here's the strategy:", list: [
              "✉️ Personal email referencing their favorite service",
              "🎁 Unique 10% offer — only for them, 7 days",
              "📱 SMS reminder after 3 days",
            ] },
            { role: "user" as const, content: "Ship it. Also review the new ratings and reply." },
            { role: "assistant" as const, content: "Campaign live. Reply drafts prepared for 4 new reviews, awaiting your approval. ⭐" },
          ],
        },
      },
      {
        id: "solution-daily",
        icon: "Bot",
        title: "Always-on AI assistant",
        description: "Not a generic chatbot — every morning it briefs you, manages your tasks, proactively pings you, and delivers weekly/monthly reports with suggestions.",
        features: [
          "Daily morning brief: bookings, revenue, priorities",
          "Automatic task and reminder management",
          "Proactive nudges: who to call back, what to post today",
          "Weekly and monthly business reports with concrete suggestions",
        ],
        chat: {
          title: "Daily assistant",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Good morning! ☀️ Here's your brief:", list: [
              "📅 5 bookings (2 new clients, 3 regulars)",
              "💰 Expected revenue: $210",
              "⚠️ 10:30 slot is empty — recall suggestion ready",
            ] },
            { role: "user" as const, content: "What should I prioritize today?" },
            { role: "assistant" as const, content: "Three things:", list: [
              "1. Anna hasn't booked in 3 weeks — send a message?",
              "2. The group class isn't posted on Instagram yet",
              "3. 2 invoices overdue — reminders ready",
            ] },
            { role: "user" as const, content: "Do all three." },
            { role: "assistant" as const, content: "Done. I'll wrap up the day at 6 PM and we'll review the weekly report together. 📊" },
          ],
        },
      },
    ],
    mockupLabels: {
      website: {
        nav1: "Home",
        nav2: "Services",
        nav3: "Pricing",
        nav4: "Contact",
        heroTitle: "Transform Your Life",
        heroDesc: "Personalized training plans and group classes with a professional trainer",
        heroBadge: "#1 Personal Trainer in Budapest",
        heroCta1: "Book Now",
        heroCta2: "Learn More",
        heroVideo: "Watch Video",
        trainerPhoto: "Pro photo",
        stat1: "Happy clients",
        stat2: "Rating",
        stat3: "Years experience",
        servicesTitle: "Services",
        seeAll: "See all",
        service1: "Personal Training",
        service2: "Group Classes",
        service3: "Nutrition",
        from: "from",
        bookNow: "Book",
        reviewerName: "Anna Kovács",
        reviewText: "I achieved fantastic results! Personal training sessions completely changed my life.",
        building: "AI is building your site...",
      },
      booking: {
        title: "Booking Calendar",
        month: "March 2026",
        search: "Search...",
        statBooked: "Bookings",
        statToday: "Today",
        statRevenue: "Revenue",
        todayLabel: "Today's Appointments",
        addNew: "New booking",
        appt1: "Personal Training",
        appt2: "Group HIIT",
        appt3: "Nutrition Consultation",
        person: "people",
        confirmed: "Confirmed",
        reminder: "Reminder sent",
        pending: "Pending",
        paid: "Paid",
        location: "Studio",
        hybrid: "Hybrid",
      },
      marketing: {
        title: "Marketing Dashboard",
        period: "Last 30 days",
        stat1: "Emails sent",
        stat2: "Open rate",
        stat3: "Click rate",
        stat4: "New clients",
        chartLabel: "Weekly conversions",
        chartLegend1: "Conversions",
        chartLegend2: "Visitors",
        vsLastWeek: "vs last week",
        totalConversions: "Total: 420 conversions",
        campaignsLabel: "Active campaigns",
        viewAll: "View all",
        campaign1: "New HIIT class - Instagram",
        campaign1Status: "AI generated • Scheduled 18:00",
        campaign2: "Monthly newsletter",
        campaign2Status: "Sent • 856 recipients",
        campaign3: "Client recall automation",
        campaign3Status: "12 clients affected • Running",
        scheduled: "Scheduled",
        sent: "Sent",
        opened: "opened",
        active: "Active",
      },
    },
  },
  useCases: {
    title: "Who is Bespire for?",
    subtitle: "We help a wide range of service providers in their daily work and growth",
    ctaBox: {
      title: "Can't find your profession?",
      description: "Bespire is the perfect solution for any service business. Try it free!",
      button: "Start now – free",
    },
    moreFeatures: "+ more",
    learnMore: "Learn more",
    cases: [
      {
        title: "Personal Trainers & Fitness Studios",
        slug: "fitness-personal-trainers",
        description: "Selling workout plans online, organizing group classes, managing memberships and passes, documenting diet consultations. Build community and grow your client base efficiently.",
        icon: "dumbbell",
        features: ["Workout plans", "Group classes", "Passes", "Online consultation"],
      },
      {
        title: "Yoga & Pilates Instructors and Studios",
        slug: "yoga-pilates-instructors",
        description: "Automatic schedule management, capacity limit settings, launching online courses, creating community space for participants. Easily manage all classes and participants.",
        icon: "heart",
        features: ["Schedule management", "Capacity limits", "Online courses", "Community space"],
      },
      {
        title: "Physiotherapists & Physical Therapists",
        slug: "physiotherapists",
        description: "Documenting and tracking treatment plans, demonstrating exercises in videos, assigning home tasks, measuring rehabilitation progress. Support your patients in recovery.",
        icon: "activity",
        features: ["Treatment plans", "Exercise videos", "Home tasks", "Progress measurement"],
      },
      {
        title: "Sports Clubs",
        slug: "sport-clubs",
        description: "Automated membership and pass management, scheduling classes and trainings, managing personal trainers, organizing group sessions. Increase membership and improve customer experience with modern tools.",
        icon: "trophy",
        features: ["Membership management", "Class scheduling", "Personal trainers", "Group sessions"],
      },
      {
        title: "Consultants & Business Coaches",
        slug: "consultants-business-coaches",
        description: "Booking online consultation appointments, organizing strategic sessions, sharing documents and materials with clients, automatic follow-up system. Professional appearance and efficient work.",
        icon: "briefcase",
        features: ["Consultations", "Document sharing", "Follow-up", "Payment plans"],
      },
      {
        title: "Therapists & Coaches",
        slug: "therapists-coaches",
        description: "Managing sessions and consultations, client tracking and documentation, launching online programs, progress monitoring. Take your practice online and reach more clients.",
        icon: "graduationCap",
        features: ["Courses", "Materials", "Exams", "Progress tracking"],
      },
      {
        title: "Nutrition Consultants",
        slug: "nutritionists",
        description: "Managing personalized meal plans, tracking and analyzing progress, sharing recipes, creating food lists. Help your clients achieve their goals with effective tools.",
        icon: "apple",
        features: ["Meal plans", "Progress tracking", "Recipes", "Food lists"],
      },
      {
        title: "Psychologists & Mentors",
        slug: "psychologists-mentors",
        description: "Organizing meetings in a secure online space, managing confidential notes encrypted, session tracking, managing long-term client relationships. Proper security and discretion.",
        icon: "brain",
        features: ["Secure system", "Encrypted notes", "Session tracking", "Long-term tracking"],
      },
      {
        title: "Hairdressers & Barbers",
        slug: "hairdressers-barbers",
        description: "Professional online booking system, automatic reminders, client card system, before-after gallery management. Clients can book 24/7, and you can see your entire daily schedule in one place.",
        icon: "scissors",
        features: ["Online booking", "Automatic reminders", "Gallery management", "Client cards"],
      },
      {
        title: "Photographers & Videographers",
        slug: "photographers-videographers",
        description: "Professional portfolio display with gallery, managing projects and packages, appointment scheduling for locations, sharing and delivering materials to clients. Show your work and simplify processes.",
        icon: "camera",
        features: ["Portfolio gallery", "Projects", "Appointment scheduling", "Material sharing"],
      },
      {
        title: "Beauticians & Beauty Salons",
        slug: "beauticians-beauty-salons",
        description: "Selling treatment packages, managing multiple staff simultaneously, automatic loyalty program tracking, storing treatment history and notes. Take your salon operations to the next level.",
        icon: "sparkles",
        features: ["Treatment packages", "Multiple staff", "Loyalty program", "Treatment records"],
      },
      {
        title: "Massage Therapists & Therapists",
        slug: "massage-therapists",
        description: "Discreet client data management, treatment history tracking, selling treatment packages and passes, automatic recurring appointments. Professional and secure system.",
        icon: "handHeart",
        features: ["GDPR security", "Treatment history", "Packages", "Recurring bookings"],
      },
      {
        title: "Nail Technicians & Nail Artists",
        slug: "nail-technicians",
        description: "Inspirational gallery of patterns, showcasing colors and styles, handling special treatments, automatic loyalty reward tracking. Attract more clients with beautiful presentation.",
        icon: "paintbrush",
        features: ["Pattern gallery", "Special treatments", "Loyalty rewards", "Booking"],
      },
    ],
  },
  features: {
    title: "What can you use the Bespire AI assistant for?",
    subtitle: "Not just sales — it supports your entire digital operation on one platform.",
    groups: [
      {
        label: "What you can sell",
        title: "Revenue streams",
        subtitle: "From daily income to passive revenue — on one platform.",
        list: [
          {
            title: "Services & Appointments",
            description: "Clients book online, you serve them - simple as that.",
            items: [
              "Haircuts, coloring, treatments",
              "Workouts and yoga classes",
              "Beauty treatments",
              "Massage and therapy",
            ],
          },
          {
            title: "Passes & Memberships",
            description: "Secure predictable, stable monthly revenue.",
            items: [
              "10-session workout pass",
              "5-session massage pass",
              "Monthly beauty package",
              "Consultation bundle (3 sessions)",
            ],
          },
          {
            title: "Group Workshops",
            description: "Organize events where you can serve multiple clients at once.",
            items: [
              "Cooking class for 8-10 people",
              "Group fitness classes",
              "Makeup workshop on weekends",
              "Wellness retreat days",
            ],
          },
          {
            title: "Consultations & Coaching",
            description: "Online or in-person meetings with clients, high added value.",
            items: [
              "Online nutrition consulting",
              "Personal styling consultation",
              "Business coaching sessions",
              "Lifestyle coaching",
            ],
          },
          {
            title: "Online Courses",
            description: "Share your expertise in video courses - create once, sell continuously.",
            items: [
              "Professional cooking techniques course",
              "Home workout program package",
              "Makeup course for beginners",
              "Yoga at home course",
            ],
          },
          {
            title: "Digital Products",
            description: "Create guides, recipes, templates - passive income source.",
            items: [
              "Meal plans and workout plans in PDF",
              "Hair care guide e-book",
              "Business templates bundle",
              "Downloadable recipe book",
            ],
          },
          {
            title: "Personal Messages",
            description: "Clients and fans can request personalized video or chat messages from you — a unique experience and extra income.",
            items: [
              "Video motivation message from a trainer",
              "Personal greeting from a coach",
              "Hair care tip video from a stylist",
              "Private chat consultation from a beautician",
            ],
          },
        ],
      },
      {
        label: "Marketing & brand",
        title: "How new clients find you",
        subtitle: "AI runs your brand, marketing and content — you just approve.",
        list: [
          {
            title: "Brand & Strategy",
            description: "The AI refines your brand, personas and business plan — and keeps rethinking them as the market shifts.",
            items: [
              "Brand and voice tuning",
              "Personas and target audience",
              "Business and marketing plan",
              "Ongoing competitor analysis",
            ],
          },
          {
            title: "Marketing & Sales",
            description: "Daily social posts, ad campaigns and email marketing — the AI brings in new clients, you just approve.",
            items: [
              "Social posts and calendar (FB, IG, TikTok)",
              "Ad campaigns and plans",
              "Email campaigns and newsletters",
              "Reactivating past clients",
              "Local partnership outreach",
            ],
          },
          {
            title: "Blog, SEO & Content",
            description: "The AI keeps filling your site with fresh content, optimizes it for Google and translates it to new languages.",
            items: [
              "Blog posts for target keywords",
              "SEO analysis and suggestions",
              "Translation to new languages",
              "New image and media generation",
            ],
          },
          {
            title: "Reactivating lost clients",
            description: "AI-suggested call-back and email sequences for clients who haven't visited recently — automated campaigns with personalized messages.",
            items: [
              "List of past clients",
              "Personalized re-engagement messages",
              "Automated reactivation campaign",
              "Return offers generated by AI",
            ],
          },
          {
            title: "Developing and implementing loyalty programs",
            description: "Build and launch points-based, pass-based or discount-based loyalty programs with AI guidance.",
            items: [
              "VIP points system",
              "Return-booking incentives",
              "Referral program",
              "Loyalty campaign scheduling",
            ],
          },
        ],
      },
      {
        label: "Growth",
        title: "Operations & growth",
        subtitle: "From client data to hiring — the AI walks you through.",
        list: [
          {
            title: "Clients & Reports",
            description: "All client data and performance numbers in one place — with deep analysis and concrete AI suggestions.",
            items: [
              "CRM: client profiles, notes",
              "Customer analytics",
              "Deep performance report with AI commentary",
              "Meeting prep in one click",
            ],
          },
          {
            title: "Team & Growth",
            description: "When it's time to grow, the AI walks you through — from the job ad to the interview questions.",
            items: [
              "Writing job ads",
              "Candidate-tailored interview questions",
              "HR marketing campaigns",
            ],
          },
          {
            title: "Automatic daily to-do management",
            description: "Every morning the AI organizes your tasks based on bookings, campaigns and deadlines — with priorities and reminders.",
            items: [
              "Automatic priority sorting",
              "Reminders and deadline tracking",
              "Meeting preparation",
              "Daily focus list generation",
            ],
          },
          {
            title: "Long-term strategy development and follow-up",
            description: "Monthly and quarterly goals, business plan updates and KPI tracking with AI support — plus continuous follow-up.",
            items: [
              "Goal setting and action plans",
              "Quarterly strategic review",
              "KPI tracking and forecasting",
              "Continuous business plan updates",
            ],
          },
          {
            title: "A real colleague who knows you, your business and your market",
            description: "Bespire learns about your business, so its suggestions become increasingly accurate and personalized — like working with an experienced colleague.",
            items: [
              "Business-specific knowledge",
              "Market trend monitoring",
              "Continuous fine-tuning",
              "Personalized recommendations",
            ],
          },
        ],
      },
    ],
  },
  howItWorks: {
    title: "How does it work?",
    subtitle: "Choose the path that suits you best",
    timeIndicator: "Start now – free",
    pathA: {
      label: "Do it yourself, with AI help",
      badge: "Self-service",
      steps: [
        {
          number: "01",
          title: "Sign up and tell us what you do",
          description: "Free account in a few clicks. The AI learns your business, goals, and clients — try it for 3 days, no commitment.",
        },
        {
          number: "02",
          title: "AI builds your operation",
          description: "Brand, catalog, marketing plan, SEO, admin workflows, and client communication — all at once, based on your inputs.",
        },
        {
          number: "03",
          title: "Daily assistant",
          description: "The AI suggests marketing, campaigns, pricing, new products, and clients to re-engage — continuously optimizing.",
        },
      ],
    },
    pathB: {
      label: "We do it for you",
      badge: "One-time 50,000 HUF + VAT",
      description: "If you'd like, we take the entire setup and training off your hands — we tailor the full AI assistant system to your business, you just use it.",
      steps: [
        {
          number: "01",
          title: "Free assessment",
          description: "In 30 minutes we review your services, clients, workflows, and goals so the AI is tailored to your business.",
        },
        {
          number: "02",
          title: "We tailor the AI assistant",
          description: "Brand, catalog, invoicing, marketing, communication, SEO, and campaigns — we build your full daily operation and train the AI to your voice.",
        },
        {
          number: "03",
          title: "Handover and we stay with you",
          description: "After personal training, Bespire works with you every day — and we stay available in the background.",
        },
      ],
    },
  },
  testimonials: {
    title: "What our clients say",
    items: [
      {
        name: "Eva Nagy",
        role: "Hairdresser",
        location: "Budapest",
        text: "After 3 years, I finally have a professional website and don't have to be on the phone all day for bookings. Bespire automated everything.",
        rating: 5,
      },
      {
        name: "Mark Kovacs",
        role: "Personal Trainer",
        location: "Debrecen",
        text: "I used to have 10-15 clients, now I have 40+ regular clients. The online booking and marketing AI worked wonders.",
        rating: 5,
      },
      {
        name: "Fitness Plus Studio",
        role: "Yoga and Pilates",
        location: "Szeged",
        text: "We work with 6 instructors and the calendar used to be chaos. Now everything is organized, clients are happy, and we save time.",
        rating: 5,
      },
    ],
  },
  cta: {
    title: "Take your business to the next level",
    subtitle: "Join hundreds of satisfied service providers",
    button: "Get started free",
    note: "No credit card required • 3-day free trial • AI assistant included in your plan • Cancel anytime",
  },
  faq: {
    title: "Frequently asked questions",
    categories: [
      {
        name: "General",
        icon: "info",
        questions: [
          {
            q: "How can I get started right away?",
            a: "Two paths: (1) Free signup, chat with the AI for 10 minutes and launch your own site — no credit card required, free for 3 days. (2) Request a callback, and within 48 hours we'll call you for a 30-minute conversation where we build the full system for you (HUF 50,000 + VAT one-time fee).",
          },
          {
            q: "Do I need technical knowledge?",
            a: "Not at all! The AI assistant guides you through every step and sets up everything automatically. If you can talk to your clients, you can use Bespire.",
          },
          {
            q: "How long does it take to get started?",
            a: "Website and booking system are ready in 10 minutes. You can start accepting clients immediately.",
          },
          {
            q: "Who is Bespire for?",
            a: "For service providers who already have a booking system, online payment, and a website, or want a new one: hairdressers, beauticians, personal trainers, yoga instructors, physiotherapists, massage therapists, dietitians, psychologists, and any other professional who sees clients.",
          },
          {
            q: "How is Bespire different from ChatGPT, Gemini, or Claude?",
            a: "ChatGPT, Gemini, and Claude are excellent for general content, but on their own they don't know your business, connect to your calendar, clients, bookings, or payments. Bespire is an AI assistant built for service providers: your website, booking system, marketing, admin, and daily tasks work together in one place, powered by your real business data.",
          },
          {
            q: "Do I need to download an app?",
            a: "No, Bespire is fully browser-based and works on both mobile and desktop. No installation needed — just open your browser and use it.",
          },
          {
            q: "How many clients and bookings can the system handle?",
            a: "Unlimited clients and bookings even on the Standard plan. The system is designed to grow with you — it easily handles dozens of bookings per day.",
          },
        ],
      },
      {
        name: "Pricing & Plans",
        icon: "creditCard",
        questions: [
          {
            q: "How much does Bespire cost?",
            a: "The Growth plan is 12,900 HUF + VAT / month with AI assistant included in your plan. The Premium plan is 24,900 HUF + VAT / month, adding more users, higher usage headroom and priority support. 3-day free trial, no credit card required. You only pay commission when selling online through us: 4% + €0.30 per transaction. On-site payments have no commission.",
          },
          {
            q: "What's included in the Growth plan?",
            a: "Everything you need: professional website, booking system, memberships and passes management, unlimited team members, custom domain, automated marketing tools, detailed analytics, and AI assistant included in your plan.",
          },
          {
            q: "Is there a quota or limit on AI use?",
            a: "No separate AI charge. The AI assistant and every AI generation (text, image, website) are part of your plan, for your daily work. No counting, no surprises. During campaigns or extreme loads, extra capacity may be needed.",
          },
          {
            q: "What does “normal business use” mean?",
            a: "It covers normal business operations — daily content creation through intensive campaign generation. We only push back on extreme, automated or non-business usage. Real business use is part of your plan — no separate limit or fee.",
          },
          {
            q: "Is there a free trial?",
            a: "Yes! You can try the full system free for 3 days with full AI assistant access, no credit card required. If you like it, continue with the Growth plan at 12,900 HUF + VAT/month.",
          },
          {
            q: "When do I pay the online payment processing fee?",
            a: "For on-site payments, there's no online payment processing fee - completely free. For online payments, it's 4% + €0.30 per transaction.",
          },

          {
            q: "What is the one-time setup package?",
            a: "The 'Full Setup' package at 50,000 HUF + VAT is a one-time service where our team sets up everything for you: website build, product and service uploads, booking system configuration, email marketing and SEO optimization, social media integration, and personal platform training. You just get started, we do the rest.",
          },
          {
            q: "Is the setup package mandatory?",
            a: "No, it's completely optional! You can set up everything yourself with the AI assistant's help. The setup package is ideal for those who don't want to deal with the technical side and want a fully working system from day one.",
          },
          {
            q: "What happens after the trial if I don't pay?",
            a: "At the end of the trial, your account is suspended but not deleted. You can return and activate your subscription within 30 days — all your data is preserved.",
          },
        ],
      },
      {
        name: "Booking System",
        icon: "calendar",
        questions: [
          {
            q: "How does the Bespire booking system work?",
            a: "Booking system: integrated part of your website, it does not redirect to an external interface.",
          },
          {
            q: "How can I manage my calendar via chat?",
            a: "Write to the AI in natural language, e.g., 'Schedule a meeting tomorrow at 2pm with Jane Smith.' The AI understands, executes, and notifies the relevant parties — like having a personal assistant.",
          },
          {
            q: "How does the membership system work?",
            a: "You can create flexible memberships: per-session, time-limited, or combined. It automatically deducts on booking, sends expiration reminders, and shows remaining sessions.",
          },
          {
            q: "Can I manage group sessions?",
            a: "Yes! Set maximum capacity, and when a session is full, an automatic waitlist starts. If someone cancels, the first person on the waitlist gets notified.",
          },
          {
            q: "Does it sync with Google Calendar?",
            a: "Yes! Two-way sync with Google Calendar: Bespire bookings appear in your Google Calendar, and your private events block time slots too — no double bookings.",
          },
          {
            q: "How does the waitlist work?",
            a: "When a time slot or group session is full, interested clients are automatically added to the waitlist. If someone cancels, the first person on the waitlist is instantly notified and can book the spot.",
          },
          {
            q: "Can I manage multiple locations or rooms at once?",
            a: "Yes! You can manage multiple locations, rooms, or service points from a single account. Each location gets its own calendar, service list, and team members.",
          },
        ],
      },
      {
        name: "Payments & Invoicing",
        icon: "receipt",
        questions: [
          {
            q: "What payment methods are supported?",
            a: "Online card payments (Visa, Mastercard), Apple Pay, Google Pay. For on-site payments (cash, card terminal) there's no platform commission.",
          },
          {
            q: "Can I issue invoices?",
            a: "Yes! You can link invoicing to the salon or set up separate billing per team member — perfect for subcontractors. Hungarian and international invoicing with VAT handling is supported.",
          },
          {
            q: "How many team members can I add?",
            a: "Unlimited — at no extra cost! Each team member gets their own calendar and permissions.",
          },
          {
            q: "When do I receive money from online payments?",
            a: "Payouts are initiated weekly, and funds typically arrive in your bank account within 2-3 business days from the payout date. You can track payouts within the platform.",
          },

          {
            q: "What currencies are supported?",
            a: "We primarily support Hungarian Forint (HUF) and Euro (EUR).",
          },
        ],
      },
      {
        name: "Website & Technical",
        icon: "globe",
        questions: [
          {
            q: "What if I already have a website?",
            a: "Just provide the URL and the AI will import your images, descriptions, and services. We build a beautiful new website from your existing content.",
          },
          {
            q: "Can I use my own domain?",
            a: "Yes! You can connect your own domain (e.g., www.myhairstudio.com) or use a free Bespire subdomain (e.g., myhairstudio.bespire.app).",
          },
          {
            q: "Is client data storage secure?",
            a: "Absolutely! We store data encrypted on EU servers, fully GDPR compliant. You control who has access.",
          },
          {
            q: "Do you use my data for anything?",
            a: "No! Your data is used exclusively to operate your services. We don't sell it, share it with third parties, use it for marketing, or use it to train AI models. Your data is yours — we just store it securely.",
          },
          {
            q: "Where is my data stored?",
            a: "All data is stored on servers within the European Union in encrypted form. We fully comply with GDPR regulations and conduct regular security audits.",
          },
          {
            q: "Can I upload a gallery or portfolio?",
            a: "Yes! You get 20 GB of storage to upload photos and videos to your website. Galleries, before-and-after images, reference work — all can be showcased on your page.",
          },
          {
            q: "Is the website SEO-optimized?",
            a: "Yes! Websites built on Bespire are automatically SEO-optimized: fast loading, mobile-friendly design, meta titles and descriptions, structured data — so clients can find you on Google.",
          },
          {
            q: "Can I create a multilingual website?",
            a: "Yes! You can make your website available in multiple languages. The AI helps with translation, but you can also edit the text in each language yourself.",
          },
          {
            q: "What happens to my data if I leave the platform?",
            a: "Your data belongs to you! Before canceling, you can export your client list, bookings, and invoices. We keep your account for 30 days after cancellation in case you change your mind.",
          },
        ],
      },
      {
        name: "AI Assistant",
        icon: "sparkles",
        questions: [
          {
            q: "What does the AI help with day to day — not just at onboarding?",
            a: "It stays with you after onboarding. You ask it in chat and it delivers: new blog post, social campaign, ad plan, email send, performance report, even a job ad — you just approve.",
          },
          {
            q: "Can it generate social posts and ads?",
            a: "Yes — Facebook, Instagram and TikTok posts, full ad campaigns and content calendars. Tuned to your brand, with images, hashtags and scheduling.",
          },
          {
            q: "Does it create blog posts and SEO content?",
            a: "Yes. Give it your keywords or topic and the AI writes the post, optimizes it for SEO, publishes it on your site and translates it to new languages.",
          },
          {
            q: "Is there a CRM and customer analytics?",
            a: "Yes. Every client's bookings, spend and notes are in one view. The AI produces deep performance reports with its own commentary and concrete suggestions on where to focus.",
          },
          {
            q: "Does it help with business plan, personas and competitor analysis?",
            a: "Yes. The AI continuously refines your brand, personas, business and marketing plan, and periodically produces fresh competitor analysis.",
          },
          {
            q: "Does it help with hiring and team growth?",
            a: "Yes. It writes job ads, builds interview questions tailored to the role and candidate, and launches HR marketing campaigns for you.",
          },
          {
            q: "Can it run email campaigns?",
            a: "Yes — it writes and sends newsletters, email campaigns and win-back messages to past clients. The AI segments and suggests topics too.",
          },
        ],
      },
      {
        name: "Support",
        icon: "headphones",
        questions: [
          {
            q: "What support do I get?",
            a: "Chat-based customer service on weekdays, 24/7 AI assistant, detailed knowledge base, and video tutorials.",
          },
          {
            q: "What happens if I cancel?",
            a: "You can cancel anytime with no long-term contracts or hidden conditions. We keep your data for 30 days after cancellation.",
          },
          {
            q: "Is there onboarding help to get started?",
            a: "Yes! The AI assistant walks you through setup step by step. You also get video tutorials, a knowledge base, and chat support.",
          },
          {
            q: "How often are new features released?",
            a: "We continuously develop the platform — typically releasing updates monthly. We prioritize new features based on user feedback and notify you of every update.",
          },
          {
            q: "Can I request a custom feature?",
            a: "Of course! We welcome suggestions — the most popular requests get built into the platform.",
          },
        ],
      },
    ],
  },
  socialProof: {
    testimonialTitle: "How Bespire helps Gonda Cili",
    testimonialSubtitle: "Real customer, real experience — see how it changed her day-to-day.",
    customersTitle: "And hundreds more service providers work with Bespire",
    customersSubtitle: "Live sites, real customers. Click and see what kind of sites AI builds.",
    videoAriaLabel: "Play the customer interview video",
    videoBadge: "Customer interview",
    durationLabel: "10 min",
    openLive: "Open live →",
    viewSite: "View her live site →",
    startYourOwn: "Start your own in 10 minutes →",
    defaultQuote: "Bespire isn't just a website — it's the key to my freedom as an entrepreneur",
    professions: {
      manualTherapist: "Manual therapist",
      lifestyleCoach: "Lifestyle coach",
      dietitian: "Dietitian",
      therapist: "Therapist",
    },
  },
  callbackForm: {
    title: "Need help? We'll call you within 48 hours",
    description: "On business days. Completely free, no obligation. We don't sell over the phone — we just check whether Bespire fits your business, and if it does, we discuss the next step.",
    whatYouGetTitle: "What you get on the call",
    benefits: [
      "A concrete recommendation tailored to your service",
      "Timeline and quote (if you ask for one)",
      "No newsletter, no follow-up calls",
    ],
    successTitle: "Thank you, we've registered your request.",
    successDescription: "We'll call you within 30 minutes on business days at the number you provided.",
    successCta: "While you wait, try the AI — you can have a live site in 10 minutes",
    phoneLabel: "Phone number",
    emailLabel: "Email",
    emailOptional: "(optional)",
    emailPlaceholder: "you@example.com",
    submitButton: "Call me back",
    privacyNote: "We handle your data confidentially (GDPR). The callback is completely free and not a sales call.",
  },
  accordion: {
    creditsDetails: "Details",
  },
  useCasesAria: {
    prev: "Previous",
    next: "Next",
  },
  proAlts: {
    presentation: "Gym - personal trainers at work",
    collaboration: "Beautician at professional work",
    discussion: "Yoga instructor leading a group class",
    meeting: "Massage therapist during a treatment",
    brainstorm: "Hairdresser working in the salon",
  },
  proCta: {
    title: "Are you a training center or professional organization?",
    description: "Your own marketplace, training management, digital content sales — a turnkey solution for professional organizations and training centers.",
    button: "I'm interested",
  },
  smbPricingPage: {
    seo: {
      title: "Pricing – Bespire | Transparent monthly fee, no surprises",
      description: "One price, two paths: DIY with AI or we set it up for you. All core features on one platform, AI assistant included, commissions and payouts in one place.",
    },
    hero: {
      badge: "Pricing",
      title: "Transparent pricing. Zero surprises.",
      subtitle: "Fixed monthly fee, access to every feature.\u00a0",
      trustPoints: [
        "3-day free trial",
        "AI assistant included in your plan",
        "No card required",
        "Cancel any time",
      ],
    },
    plansHeading: {
      title: "Pick the plan that fits you",
      subtitle: "Both plans include the same AI features and core tools — the difference is daily usage intensity.",
    },
    billingToggle: {
      monthly: "Monthly",
      annual: "Annual",
      saveBadge: "2 months free",
      annualHint: "With annual billing you get 2 months free — annual price equals monthly × 10.",
    },
    fairUseReassurance:
      "Your plan includes the AI assistant for normal daily use. During campaign seasons, heavy usage or extreme automated loads, extra capacity may be needed.",
    quickWins: {
      title: "What you can do with it today",
      items: [
        { text: "Draft an Instagram post", eta: "~10 sec" },
        { text: "Reply to an unhappy customer message", eta: "~30 sec" },
        { text: "Generate a full website page for a new service", eta: "~2 min" },
        { text: "Write a business plan for your next expansion", eta: "~5 min" },
      ],
      more: {
        title: "…and a lot more",
        description: "Newsletters, offers, blog posts, image generation, SEO copy, customer replies, campaign ideas — anything that can be written or generated, we've got you covered.",
      },
    },
    tsmtPartner: {
      badge: "TSMT® partner",
      title: "Are you a TSMT® therapist?",
      description: "Certified TSMT® therapists — with a valid registration number — get a partner discount on the Growth and Premium plans, on both monthly and annual billing.",
      year1Label: "Year 1",
      year1Value: "−40%",
      year2Label: "Year 2",
      year2Value: "−20%",
      examplesHeading: "Example net prices",
      examples: [
        "Growth HUF 12,900 → Year 1: HUF 7,740/mo · Year 2: HUF 10,320/mo",
        "Premium HUF 24,900 → Year 1: HUF 14,940/mo · Year 2: HUF 19,920/mo",
      ],
      disclaimer: "Net prices, + VAT. Discount verified via TSMT® registration number.",
      ctaPrimary: "Request with registration number",
      ctaSecondary: "What is this?",
    },

    plans: {
      standard: {
        title: "Growth",
        price: "HUF 12,900",
        priceSuffix: " + VAT / mo",
        highlight: "Light–moderate AI usage",
        usageBadge: "Around 5–10 AI tasks per day",
        note: "3-day free trial · no card required",
        rollover: "",
        annual: {
          price: "HUF 10,750",
          priceSuffix: " + VAT / mo",
          perYearLabel: "Annual: HUF 129,000 + VAT",
          saveLabel: "You save: HUF 25,800 / year",
        },
        features: [
          "Full system: website, booking, payments",
          "AI assistant included in your plan",
          "Multiple users and multiple locations",
          "Automated marketing tools",
          "Custom domain and local-language support",
        ],
        aiCapabilitiesTitle: "What you can do with the AI",
        aiCapabilityGroups: [
          {
            title: "Social media and content",
            items: [
              "Instagram and Facebook posts with copy and image",
              "TikTok script and video ideas",
              "Story and Reels captions",
              "Hashtag and timing suggestions",
              "Weekly content calendar draft",
            ],
          },
          {
            title: "Website and SEO",
            items: [
              "New subpage or landing page copy",
              "Product and service descriptions",
              "Blog outline and intro",
              "Meta title and description",
              "FAQ expansion and rewriting",
            ],
          },
          {
            title: "Customer communication",
            items: [
              "Customer email replies and templates",
              "Booking and reminder templates",
              "Complaint handling responses",
              "Quote email drafts",
              "Thank-you and follow-up messages",
            ],
          },
          {
            title: "Marketing campaigns",
            items: [
              "Newsletter body and subject line",
              "Seasonal campaign ideas",
              "Simple A/B alternatives",
              "Social ad copy drafts",
            ],
          },
          {
            title: "Business tasks",
            items: [
              "Short business plan outline",
              "Pricing suggestions",
              "Competitor summary",
              "Meeting note summary",
            ],
          },
        ],
        cta: "Start free",
        footnote: "No card · 3-day full access",
        trustNote: "Cancel any time · No commitment",
        extraTitle: "Who is it for?",
        extraDescription: "For solo providers and small teams who want to use AI for marketing, content and website work.",
        extraExample: "Example: around 3–5 posts a week, occasional website updates, a handful of bookings handled manually.",
      },
      pro: {
        title: "Premium",
        badge: "Most popular",
        price: "HUF 24,900",
        priceSuffix: " + VAT / mo",
        highlight: "Heavy AI usage",
        usageBadge: "20+ AI tasks per day, more users and locations",
        note: "3-day free trial · no card required",
        rollover: "",
        annual: {
          price: "HUF 20,750",
          priceSuffix: " + VAT / mo",
          perYearLabel: "Annual: HUF 249,000 + VAT",
          saveLabel: "You save: HUF 49,800 / year",
        },
        features: [
          "Everything in Growth — optimized for heavier usage",
          "Priority support — faster response times for intensive operations",
          "Higher load capacity during campaign seasons — 20+ AI tasks per day",
        ],
        aiCapabilitiesTitle: "Same AI features, with heavier usage",
        aiCapabilityGroups: [
          {
            title: "Social media and content",
            items: [
              "Instagram and Facebook posts with copy and image",
              "TikTok script and video ideas",
              "Story and Reels captions",
              "Hashtag and timing suggestions",
              "Weekly content calendar draft",
            ],
          },
          {
            title: "Website and SEO",
            items: [
              "New subpage or landing page copy",
              "Product and service descriptions",
              "Blog outline and intro",
              "Meta title and description",
              "FAQ expansion and rewriting",
            ],
          },
          {
            title: "Customer communication",
            items: [
              "Customer email replies and templates",
              "Booking and reminder templates",
              "Complaint handling responses",
              "Quote email drafts",
              "Thank-you and follow-up messages",
            ],
          },
          {
            title: "Marketing campaigns",
            items: [
              "Newsletter body and subject line",
              "Seasonal campaign ideas",
              "Simple A/B alternatives",
              "Social ad copy drafts",
            ],
          },
          {
            title: "Business tasks",
            items: [
              "Short business plan outline",
              "Pricing suggestions",
              "Competitor summary",
              "Meeting note summary",
            ],
          },
        ],
        cta: "Start free",
        footnote: "No card · 3-day full access",
        trustNote: "Cancel any time · No commitment",
        extraTitle: "Who is it for?",
        extraDescription: "For businesses and teams that use AI more intensively — more posts, more campaigns, more locations, more users — and want priority support.",
        extraExample: "Example: multiple posts per day, regular campaigns, several website edits per week, active management of multiple locations and team members.",
      },
      setup: {
        title: "We set it up for you",
        price: "HUF 50,000",
        priceSuffix: " + VAT one-time",
        note: "then the monthly plan you pick (Growth or Premium)",
        description: "If you don't have time to configure the system yourself, our team uploads your services, sets up booking, payments and your domain, and walks you through it personally.",
        cta: "Request a callback",
        footnote: "We call you back within 48h on business days · free, no commitment",
      },
    },
    creditsRollover: {
      title: "",
      description: "",
    },
    chatFreeExamples: [
      "Marketing brainstorming, campaign planning",
      "Polishing and rewriting copy",
      "Questions about the system, setup help",
    ],

    bothPlansInclude: {
      badge: "In both plans",
      title: "One subscription, everything you need",
      subtitle: "Growth and Premium give you the same system and the same AI capabilities. The difference is the intensity of daily use.",
      system: {
        title: "System",
        items: [
          "Website with your own domain",
          "Online booking and email reminders",
          "Passes, packages, memberships",
          "Online and on-site payments",
          "Automatic invoicing via Számlázz.hu",
          "Customer records",
          "Add team members",
          "Your own branding: colors, logo",
        ],
      },
      ai: {
        title: "AI assistant for your daily work",
        items: [
          "Conversational AI assistant in Hungarian",
          "Text generation: posts, newsletters, product copy, SEO",
          "Image generation for your brand",
          "Website and subpage generation",
          "Marketing and campaign ideas, content calendar",
        ],
        fairUseNote: "Included in your plan, no separate AI charge. Unlimited within fair use — during campaign seasons or extreme load, extra capacity may be needed.",
      },
      trial: {
        badge: "3-day free trial",
        note: "After signing up you get 3 days of full access to everything — no card required.",
      },
    },

    alwaysIncluded: {
      title: "One platform, all core features",
      subtitle: "Your plan includes the complete system with AI for your daily work — only intensity of daily use differs.",

      categories: [
        {
          title: "Booking and calendar",
          items: [
            "Unlimited bookings",
            "Automatic reminders (email)",
            "Group classes and waitlist",
            "Calendar synchronization",
            "Multiple locations, rooms, staff",
          ],
        },
        {
          title: "Payments and passes",
          items: [
            "Online payments (cards, Apple Pay)",
            "On-site payment recording",
            "Passes, packages, memberships",
            "Automatic invoicing",
            "Weekly automatic payouts to your bank account",
          ],
        },
        {
          title: "Website and brand",
          items: [
            "Professional website (mobile-friendly)",
            "Custom domain",
            "Unlimited pages and subpages",
            "Search-optimized website",
            "Your own branding, colors, logo",
          ],
        },
        {
          title: "Customers and team",
          items: [
            "Unlimited customer records",
            "Unlimited team members",
            "Customer notes and history",
            "Detailed statistics and reports",
            "Web-based platform, no install needed",
          ],
        },
      ],
    },
    credits: {
      badge: "AI assistant included",
      title: "AI for your daily work — included in your plan",
      subtitle: "The AI assistant and all AI generations (text, image, website) are for your daily work — included in your plan. No separate AI charge, no counting, no surprises.",
      whatIsTitle: "What does included mean?",
      whatIsDescription: "Your plan fee covers the AI assistant and AI generation for normal daily business use. During campaign seasons, heavier usage or extreme automated use, extra capacity may be needed.",
      examplesTitle: "How you'll use it day to day",
      packagesTitle: "",
      packagesIntro: "",
      freeBadge: "3-day free trial",
      freeNote: "After signing up you get 3 days of full access to the AI assistant and every feature — no card required.",
      monthlyIncluded: {
        title: "What's included in both plans",
        standard: "Growth: AI assistant for your daily work",
        pro: "Premium: AI assistant for your daily work — more users, priority support",
        overflow: "No separate AI charge, no counting — use it within your plan, whenever and however you need.",
      },
      chatFree: {
        title: "AI assistant and AI generation — included in your plan",
        description: "Chat with the AI about marketing ideas, co-write copy, generate posts, images or websites — all included in your plan.",
      },
    },

    payments: {
      badge: "Payments and fees",
      title: "The only fee is the card processing fee on online payments",
      subtitle: "On-site payments (card, cash, transfer) carry zero fees. For online payments the card processing fee goes to the payment provider — it's not Bespire revenue, just the standard cost of the transaction.",
      cards: [
        {
          title: "On-site payment",
          highlight: "€0 fee",
          description: "Cash, card or transfer — we don't take a cut. You collect it, you keep it.",
        },
        {
          title: "Card processing fee (online)",
          highlight: "4% + €0.30",
          description: "Per transaction, paid to the payment provider. This isn't Bespire revenue — we don't earn anything on it.",
        },
        {
          title: "Weekly payouts",
          highlight: "Weekly",
          description: "Your online revenue is automatically transferred to your bank account every week, within 2-3 business days of the transaction.",
        },
      ],
      invoicing: {
        badge: "Invoicing integration",
        title: "Works for VAT-registered and VAT-exempt businesses alike",
        description: "Whether you charge VAT or are VAT-exempt — the system handles both. Connect your invoicing account and we automatically generate an official invoice for every purchase.",
        bullets: [
          "Automatic invoice for every transaction",
          "VAT and VAT-exempt modes supported",
          "One-click invoicing integration",
        ],
      },
    },
    setupOffer: {
      badge: "Optional extra · One-time service",
      title: "No time to set it up? We'll do it for you.",
      subtitle: "An optional one-time service alongside your Standard or Pro subscription — not a recurring fee. Pay once and our team hands you a fully working system, turnkey.",
      price: "€139",
      priceSuffix: "+ VAT · one-time",
      valueProp: "A working system from day one, turnkey.",
      bullets: [
        "Discovery call and brand-tailored website",
        "Services, prices and photos uploaded for you",
        "Booking calendar, team and reminders configured",
        "Online payments, custom domain, auto-invoicing",
        "10–15 starter social media posts with AI + SEO basics",
        "1-hour personal onboarding + 30 days priority support",
      ],
      guarantee: "Satisfaction guarantee: full refund within 14 days if it's not for you.",
      ctaLabel: "Request a callback",
      footnote: "One-time fee, optional add-on to your Standard or Pro subscription.",
    },
    comparison: {
      title: "One subscription. All the tools you need.",
      subtitle: "Bespire isn't a booking tool — it's a complete business toolbox. You get in one place what used to require 5-8 separate services.",
      toolsTitle: "What does Bespire replace?",
      tools: [
        { icon: "Bot", name: "AI assistant", alt: "No real alternative" },
        { icon: "FileText", name: "Full website builder", alt: "Instead of Carrd, Leadpages" },
        { icon: "Calendar", name: "Online booking", alt: "Instead of Calendly, SimplyBook" },
        { icon: "CreditCard", name: "Online payments", alt: "Instead of separate Stripe / Barion integration" },
        { icon: "Sparkles", name: "AI content & image generator", alt: "Instead of ChatGPT Plus, Canva Pro" },
        { icon: "Megaphone", name: "Social media manager", alt: "Instead of Buffer, Later, Meta Business" },
        { icon: "Users", name: "Customer / CRM", alt: "Instead of HubSpot, MiniCRM" },
        { icon: "Bell", name: "Automatic reminders", alt: "Instead of separate SMS / email tools" },
        { icon: "Mail", name: "Email marketing", alt: "Instead of Mailchimp, Brevo" },
        { icon: "Repeat", name: "Subscriptions & passes", alt: "Instead of separate membership and pass systems" },
        { icon: "Star", name: "Reviews & ratings", alt: "Instead of Trustpilot, Google review managers" },
        { icon: "MessageSquare", name: "Automated email notifications and review requests", alt: "Instead of Intercom, Tidio" },
        { icon: "Package", name: "Digital content sales", alt: "Instead of separate webshop / Gumroad" },
        { icon: "BarChart3", name: "Stats & reports", alt: "Instead of Google Analytics, custom dashboards" },
        { icon: "Image", name: "Gallery & media library", alt: "Instead of separate image-sharing tools" },
        { icon: "Video", name: "Personal video messages", alt: "Instead of separate video message services" },
      ],
      summaryLabel: "Bought separately",
      summaryOthers: "~€140 – €340 / mo",
      summaryBespire: "€39 + VAT / mo",
      summaryBespireLabel: "With Bespire (Standard plan)",
      example: {
        badge: "Real example",
        title: "A typical user's month",
        personaName: "Anna – massage therapist / small studio",
        personaDetails: "1 location · ~80 bookings / mo · active social presence + newsletter",
        costsTitle: "What did she spend that month?",
        costs: [
          { label: "Bespire Growth subscription", value: "HUF 12,900 + VAT", tag: "AI assistant included" },
          { label: "AI assistant and AI generation", value: "€0", tag: "included" },
          { label: "Online payment fee", value: "only if paid online (4% + €0.30 / transaction)" },
        ],
        costsSummary: { label: "Total", value: "HUF 12,900 + VAT" },

        creditsTitle: "What did she get done this month?",
        credits: [
          { label: "80+ bookings handled automatically (confirmations, reminders)" },
          { label: "10 social media posts written + image generation" },
          { label: "New landing page and website sections created" },
          { label: "Product descriptions and promo campaign copy" },
          { label: "Posters, story templates and design assets" },
          { label: "Newsletter sent to the full customer list" },
          { label: "Customer data and feedback managed in one place" },
        ],
        creditsTotal: "A full month of business — marketing, bookings and customer management on one platform.",
        savingsTitle: "What did this one month replace?",
        savingsIntro: "A Bespire subscription replaces your website builder, booking system, AI tools, CRM, newsletter sender and payment system — all in one place, for one price.",
        savingsHighlight: "~€110 – €350",
        savingsMoneyLabel: "saved every month",
        savingsTimeHighlight: "Several hours",
        savingsTimeLabel: "saved on daily admin work",
        savingsSubnote: "No more separate invoices, separate logins or separate monthly fees — everything runs on one platform.",
      },
    },

    competitorTable: {
      title: "Bespire vs. a separate website + booking tool + general AI",
      subtitle: "What you get with a single Bespire subscription — vs. what you'd have to stitch together from separate tools (website builder, booking system, ChatGPT / Gemini / Claude) to come close.",
      columns: {
        feature: "Feature",
        bespire: "Bespire",
        others: "Website + booking + ChatGPT / Gemini / Claude",
      },
      rows: [
        { name: "Knows your services, prices and customers", bespire: "Yes — tuned to your business", others: "No — you have to re-explain every time" },
        { name: "Local-language AI tuned for service providers", bespire: true, others: "Generic AI, often translation-flavored" },
        { name: "AI has access to your booking calendar and customer data", bespire: true, others: "No — separate system, manual copy-paste" },
        { name: "AI website generation and editing", bespire: "Included", others: "Separate website builder + manual transfer" },
        { name: "Online booking system", bespire: true, others: "€6–45 / mo (separate tool)" },
        { name: "Automated customer communication (reminders, follow-ups, newsletters)", bespire: "Automatic, based on bookings", others: "Separate tool + manual list management" },
        { name: "AI content (posts, images, ads) tailored to your services", bespire: "Based on your own data", others: "Generic AI, brief everything by hand" },
        { name: "Online payments, digital products, passes", bespire: true, others: "Separate webshop / payment integration" },
        { name: "One platform, one subscription, one support", bespire: true, others: "3–4 separate vendors, separate invoices" },
        { name: "Local-language support", bespire: true, others: "Usually English only" },
      ],
      partial: "Partially",
      totalLabel: "Total per month",
      totalBespire: "HUF 12,900 + VAT",
      totalOthers: "€100–350 / mo across multiple invoices (website + booking + AI subscription)",
    },

    faqTitle: "Frequently asked pricing questions",
    pricingFaq: [
      {
        q: "Which plan should I pick?",
        a: "Growth (HUF 12,900 + VAT / mo) is perfect to start and for solo providers — AI assistant included in your plan. Premium (HUF 24,900 + VAT / mo) is for those who use AI intensively every day. You can switch plans any time.",
      },
      {
        q: "Is there a quota or limit on AI use?",
        a: "No separate AI charge. The AI assistant and every AI generation (text, image, website) are part of your plan, for normal business use. No counting, no surprises. During campaign seasons or extreme loads, extra capacity may be needed.",
      },
      {
        q: "What does “normal business use” mean?",
        a: "It covers normal business operations — daily content creation through intensive campaign generation. We only push back on extreme, automated or non-business usage. Real business use is part of your plan — no separate limit or fee.",
      },
      {
        q: "What happens during the trial?",
        a: "You get 3 days of full access to every feature, including full AI assistant use. No card required, cancel any time.",
      },
      {
        q: "Are there commissions on my sales?",
        a: "On-site payments (card, cash, transfer) carry 0% commission. Online payments have a 4% + €0.30 / transaction processing fee paid to the provider — Bespire earns nothing on that.",
      },
      {
        q: "How much is setup if I don't want to do it myself?",
        a: "HUF 50,000 + VAT one-time, covering full setup, content upload, domain and payment integration, plus a 1-hour personal onboarding. After that you pay the plan you choose (Growth or Premium).",
      },
      {
        q: "Can I cancel any time?",
        a: "Yes, no commitment. Monthly subscription, cancel before the next cycle — no exit fee.",
      },
    ],
    finalCta: {
      title: "Ready to get started?",
      subtitle: "Try it free for 3 days with full AI assistant access, or request a callback and we'll set everything up for you.",
      diyButton: "Start now – free",
      setupButton: "Request a callback",
      footnote: "No card · 3-day full access · Cancel any time",
    },
    backToLanding: "Back to the homepage",
    detailedCtaLink: "See detailed pricing",

  },
  beforeAfterOnboarding: {
    badge: "Not just a launch — a growth partner",
    title: "Onboarding is only the beginning",
    subtitle: "Most tools build your website and leave you alone. The Bespire AI assistant stays with you from day one and works on something new every day.",
    before: {
      label: "During onboarding",
      title: "Builds everything you need to launch",
      items: [
        "Brand, positioning, service packages",
        "Website, booking system, passes and payments",
        "Products, pricing, invoicing and admin setup",
        "First marketing plan, personas, keywords, SEO basics",
        "Client communication templates (email, messages, reminders)",
      ],
    },
    after: {
      label: "After onboarding",
      title: "Works with you every day to grow the business",
      items: [
        "Daily brief and to-do list every morning",
        "New posts, campaigns, ad plans",
        "Re-activating past clients, email and message campaigns",
        "Admin: invoices, receivables, monthly report with AI commentary",
        "New products, passes, bundles, pricing suggestions",
        "Proactive ideas: what to focus on today and this week",
      ],
    },
  },
  aiAssistantCapabilities: {
    badge: "What the AI assistant can do",
    title: "One assistant that actually handles everything",
    subtitle: "It doesn't disappear when onboarding ends — it keeps planning, writing, analyzing and building for you. Here's what it helps with day to day:",
    groups: [
      {
        icon: "Palette",
        title: "Brand and strategy",
        description: "Rethinks your brand and business plan whenever you need — and keeps fine-tuning as you grow.",
        items: [
          "Brand redesign",
          "Rethinking personas",
          "Rethinking and evolving the marketing plan",
          "Business plan drafting and review",
          "Business card design",
          "New competitor analysis",
        ],
      },
      {
        icon: "Globe",
        title: "Website, content, SEO",
        description: "Doesn't just build the site — keeps filling it with content, optimizing it and translating it.",
        items: [
          "New blog posts",
          "Keyword filling",
          "SEO analysis",
          "Translating into a new language",
          "Media library and new image generation",
          "New documents for products",
        ],
      },
      {
        icon: "Calendar",
        title: "Booking & calendar",
        description: "Online booking, group classes, reminders, no-show follow-up — your calendar runs itself.",
        items: [
          "Online booking on your site",
          "Group and 1:1 sessions",
          "Automatic confirmations and reminders",
          "Calendar sync with Google/Apple/Outlook",
          "No-show follow-up and waitlist handling",
        ],
      },
      {
        icon: "Megaphone",
        title: "Marketing and sales",
        description: "From daily social posts to ad campaigns — the AI keeps bringing in new clients.",
        items: [
          "New post and post plan",
          "New ad campaign and ad plan",
          "Launching email campaigns",
          "Reactivating past clients",
          "Finding local partnerships",
        ],
      },
      {
        icon: "BarChart3",
        title: "Clients and analytics",
        description: "Deeply understands your clients and numbers — not just a report, but concrete recommendations.",
        items: [
          "Strengthening CRM — buyer analytics",
          "Deep performance report with AI commentary",
          "Meeting preparation",
          "New features in the user admin",
        ],
      },
      {
        icon: "UserPlus",
        title: "Team and growth",
        description: "When it's time to hire, the AI walks you through the whole process — from the ad to the interview questions.",
        items: [
          "Writing the job ad",
          "Interview question set",
          "HR marketing campaign",
        ],
      },
    ],
    footnote: "Just tell it in chat what you need — the AI creates it, and you approve with one click.",
  },
  heroVibiz: {
    eyebrow: "AI assistant for service providers",
    title: "Get your own AI assistant",
    subtitle: "Bespire is an AI assistant that helps you run your business day by day — from brand to customer relations, admin to daily tasks. Pick where you're starting from.",
    tabs: {
      haveSite: "I have a website",
      fromIdea: "Start from an idea",
    },
    tabSubtitles: {
      haveSite: "Drop your website URL — Bespire learns your business and from that moment works as your assistant: it writes, books, invoices, measures and plans.",
      fromIdea: "Describe in a few sentences what you do — Bespire fills in the missing pieces and from there guides you as your daily AI assistant.",
    },
    placeholders: {
      haveSite: "e.g. yourwebsite.com",
      fromIdea: "e.g. I'm a personal trainer in Budapest, for beginners…",
    },
    submit: "Start",
    callbackPill: "Or book a 30‑minute demo",
    microcopy: "3 days free · no card needed · local‑language support",
  },
  ideaToRevenue: {
    title: "From an idea or URL to live revenue",
    subtitle: "Watch Bespire extract your brand, ship the assets, launch the campaigns and wire up payments. Your business, on autopilot.",
  },
  howItWorks3: {
    title: "How it works",
    subtitle: "Three steps. Whether you're starting or scaling.",
    steps: [
      {
        label: "01",
        title: "Drop a URL or an idea",
        description: "Paste your live site, or describe the business you want to run. Bespire pulls the brand, the audience and the angle.",
        chip: "yourwebsite.com",
      },
      {
        label: "02",
        title: "We build the whole stack",
        description: "Website, booking calendar, services and passes, social posts, ad creatives, email campaigns — generated, not templated.",
        chip: "+ AI assistant",
      },
      {
        label: "03",
        title: "Launch and get paid",
        description: "We schedule organic posts, launch paid ads across Meta, TikTok and Google, and your booking‑to‑payment flow is live from day one.",
        chip: "Live",
      },
    ],
  },
  businessMarquee: {
    title: "Tailored for service providers",
    subtitle: "Fitness, yoga, beauty and hair, coaching, therapy, education, contracting and gardening. Every niche, on‑brand.",
    hint: "Click your profession",
    alts: [
      "Fitness trainer at work",
      "Yoga class",
      "Beauty salon",
      "Massage therapy",
      "Hair salon",
      "Nail studio",
      "Contractor at work",
      "Photo studio",
      "Coach with client",
      "Psychologist office",
      "Nutrition consultation",
      "Sports club interior",
      "Therapist with child",
      "Gardening and landscaping",
    ],
  },
  studios: {
    title: "Purpose‑built studios",
    subtitle: "Deep‑dive tools inside Bespire — each with its own workflow.",
    items: [
      {
        badge: "Website Studio",
        title: "One prompt — a website that matches your brand",
        description: "Give it your idea or your current URL and get a launch‑ready site in minutes — not templated, tailored to your services.",
        cta: "Website Studio",
        href: "/website-builder",
      },
      {
        badge: "Booking Studio",
        title: "Bookings, passes and payments in one place",
        description: "Online calendar, group and 1:1 sessions, passes, deposits and automatic reminders — clients don't need to download anything.",
        cta: "Booking Studio",
        href: "/booking-system",
      },
      {
        badge: "Marketing Studio",
        title: "Social posts and ads on autopilot",
        description: "Monthly plan, scheduling to Instagram, Facebook and TikTok, and AI‑generated ad creatives — always aligned with your brand.",
        cta: "Marketing Studio",
        href: "/marketing-automation",
      },
    ],
  },
  wallOfLove: {
    title: "Wall of love",
    subtitle: "Service providers already working with Bespire.",
    rating: "4.9/5",
    ratingSuffix: "from early users",
    quotes: [
      { name: "Cili", role: "Gonda‑Geszler movement therapist", quote: "In 10 minutes I had working business tools in hand: my own site, a booking calendar and a first marketing plan — no more stitching tools together." },
      { name: "Anna", role: "Beautician, Budapest", quote: "The AI writes my weekly posts and ads — I just approve them. I finally have more time in the salon." },
      { name: "Peter", role: "Personal trainer", quote: "Passes, payments and calendar in one place. Clients don't need an app, they just book and show up." },
      { name: "Réka", role: "Yoga instructor", quote: "The whole schedule and weekly newsletter runs itself. I can finally focus on yoga." },
      { name: "Mark", role: "Business coach", quote: "The AI helped with positioning and wrote my first cold campaign. Three new clients in two weeks." },
      { name: "Zsófi", role: "Hairdresser, Debrecen", quote: "Photos become polished Instagram posts in one click. Clients keep saying the site looks great." },
      { name: "Bence", role: "Nutrition coach", quote: "My packages and bookings are in one place. The AI even writes blog posts on my topics." },
      { name: "Nora", role: "Psychologist", quote: "Discreet, clean look and secure booking — exactly what my practice needed." },
      { name: "Gabor", role: "Sports club owner", quote: "Group classes, passes and marketing — finally in one place, not three tools." },
      { name: "Kata", role: "Massage therapist, Szeged", quote: "The AI handles reminders, no-shows dropped to a third. I finally see who's coming and who's slipping away." },
      { name: "Dora", role: "Nail technician", quote: "The system watches returning clients — if someone hasn't visited in two months, I get a suggestion. I just approve." },
      { name: "Tamas", role: "Physiotherapist", quote: "Invoicing and the weekly report just happen. I forward it to my accountant — no more Excel work." },
    ],
  },
  assistantCrossLinks: {
    badge: "More AI assistant capabilities",
    title: "Discover what else Bespire can do for you",
    subtitle: "One platform, three powerful workflows — all powered by the same AI assistant.",
    items: {
      websiteBuilder: {
        title: "AI website builder",
        description: "A unique, branded website in minutes — editable in chat, publishable to your own domain.",
        cta: "Open website builder",
      },
      bookingSystem: {
        title: "Booking system",
        description: "Online calendar, group and 1:1 sessions, passes, deposits, WhatsApp reminders. No app for your clients.",
        cta: "Open booking system",
      },
      marketingAutomation: {
        title: "Marketing automation",
        description: "AI generates and schedules posts for Instagram, Facebook and TikTok. Ad creatives and email campaigns too.",
        cta: "Open marketing automation",
      },
    },
    viewAll: "See all AI capabilities",
  },
};
